module.exports = new __parcel__URL__("GT-Pantheon_animation-fig-2.2-A-003.94a8a44b.json").toString();